import React, { useEffect, useState } from "react";
import { StyledContainer, StyledFormPanel, StyledBrandLogo } from "./styled";
import { locale } from "../../utils/LocaleManager";
import { Bounce, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "../../components/Button";
import { CircularProgress } from "@mui/material";
import { AuthError, EventType } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { AuthResult } from "../../enums/authResult";

const LandingScreen = () => {
  const { instance, accounts } = useMsal();
  const [success, setSuccess] = useState(false);

  const onLogin = async () => {
    await instance
      .loginPopup({
        scopes: ["User.Read"],
      })

      .then((response) => console.log("response", response))
      .catch((error) => console.log("error", error));

    const myAccounts = instance.getAllAccounts();
    const account = myAccounts[0];
    instance.setActiveAccount(account);

    await instance
      .acquireTokenSilent({
        scopes: [],
      })
      .then((tokenResponse) => {
        localStorage.setItem(AuthResult.IdToken, tokenResponse.idToken);
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    if (success) {
      toast.success("Authetication Successful. Redirecting...", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        onClose: () => window.location.assign("/main"),
      });
    }
  }, [success]);

  useEffect(() => {
    setSuccess(accounts.length > 0);
  }, [accounts]);

  useEffect(() => {
    const callbackId = instance.addEventCallback((message) => {
      if (message.eventType === EventType.LOGIN_FAILURE) {
        if (message.error instanceof AuthError) {
          const error: AuthError = message.error;
          if (error.errorCode === "user_cancelled") return;
          toast.error(`${error.message}`, {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            pauseOnFocusLoss: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
        }
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance]);

  return (
    <StyledContainer>
      <StyledBrandLogo />
      <StyledFormPanel>
        {success ? (
          <CircularProgress color="secondary" />
        ) : (
          <Button
            variant="contained"
            size="large"
            color="secondary"
            onClick={onLogin}
          >
            {locale.login}
          </Button>
        )}
      </StyledFormPanel>
    </StyledContainer>
  );
};

export default LandingScreen;
